import { gql } from "@apollo/client";

export const updateTag = gql`
  mutation UpdateTag($oldName: String!, $newName: String!, $type: TagType!) {
    updateTag(oldName: $oldName, newName: $newName, type: $type)
  }
`;
